module.exports = __webpack_public_path__ + "img/sj.062289a7.png";